<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title><v-icon color="blue">mdi-format-list-bulleted</v-icon></v-toolbar-title>
      <base-breadcrumbs :items="breadcrumbs" />
    </v-toolbar>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="success" size="50">
                    <v-icon dark>mdi-google-classroom</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <v-list-item-title>
                      <v-label color="caption"><small>Nama Kelompok KP </small></v-label>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <span class="body-1 black--text">
                        <strong> {{ $getDeepObj(detail, 'nama') || '-' }} </strong>
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" :md="api === 'kp' ? 3 : 6" sm="12">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0 px-1">
                    <v-list-item-title>
                      <v-label color="caption"><small>Jadwal yang ditugaskan</small></v-label>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <div>
                        <div v-if="api === 'kp'">
                          <template v-if="getLastPendampingan(detail)">
                            <v-chip small color="success">
                              Pertemuan
                              {{
                                (getLastPendampingan(detail) && getLastPendampingan(detail)['pendampingan_ke']) || '-'
                              }}
                            </v-chip>
                          </template>
                          <template v-else>-</template>
                        </div>
                        <div v-else>
                          <v-chip v-if="getLastPendampingan(detail).length === 4" color="success" small>
                            Semua Jadwal
                          </v-chip>
                          <v-chip
                            v-else
                            v-for="(diklat, d) in getLastPendampingan(detail)"
                            :key="d"
                            class="mr-1"
                            small
                            color="success"
                          >
                            Jadwal
                            {{ $getDeepObj(diklat, 'pendampingan_ke') || '-' }}
                          </v-chip>
                        </div>
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col v-if="api === 'kp'" cols="12" md="3" sm="12">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0 px-1" v-if="$allow('psp-peserta-kp.update')">
                    <v-list-item-title>
                      <v-label color="caption"><small>Aksi </small></v-label>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <div class="blue--text">
                        <v-btn color="orange" dark small depressed @click="onEdit(detail)">
                          <v-icon left>mdi-pencil</v-icon> Edit
                        </v-btn>
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col v-if="api === 'pendampingan'" cols="12" md="6" sm="12">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="success" size="50">
                    <v-icon dark>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <div class="blue--text body-1">{{ $getDeepObj(preferensi, 'akun.nama') }}</div>
                    <div class="black--text body-2">Email: {{ $getDeepObj(preferensi, 'akun.email') }}</div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>

            <v-expansion-panels flat class="my-2">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <template v-slot:default="{ open }">
                    <div>
                      <v-toolbar flat>
                        <v-toolbar-title class="body-1 pa-0 ml-n5">
                          <span class="blue--text">
                            {{ ($getDeepObj(detail, 'psp_kp_sekolahs.data') || []).length }}
                          </span>
                          Sekolah Anggota Pendampingan KP
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <span class="text-right blue--text">
                          {{ open ? 'Sembunyikan Daftar' : 'Lihat Selengkapnya' }}
                        </span>
                      </v-toolbar>
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-for="item in $getDeepObj(detail, 'psp_kp_sekolahs.data') || []" :key="item.sekolah_id">
                    <v-col cols="12" md="6" sm="12">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-hospital-building</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <div class="blue--text">
                            {{ $getDeepObj(item, 'nama') || $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                          </div>
                          <div class="black--text">
                            <b>NPSN : </b>
                            {{ $getDeepObj(item, 'npsn') || $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Alamat Sekolah </small></v-label>
                          </v-list-item-title>
                          <div class="link black--text body-2">
                            {{ $getDeepObj(item, 'alamat') || $getDeepObj(item, 'sekolah.data.alamat') || '-' }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mt-5" flat>
      <v-card-text class="black--text pa-5">
        <h3>Berikut Detail Jadwal Pertemuan</h3>
        <div class="body-1">
          Pilih salah satu untuk melihat detail dari Jadwal Pertemuan<br />
          <b>{{ $getDeepObj(detail, 'nama') || '-' }}</b>
        </div>
        <v-spacer class="my-2" />
        <v-row>
          <template v-for="pt in mPertemuan">
            <v-col :key="pt.value" cols="12" md="3" sm="12">
              <v-card
                outlined
                :dark="kPertemuan === pt.value"
                :color="kPertemuan === pt.value ? 'green' : ''"
                :disabled="pt.disabled"
                class="ma-1"
                style="border-radius: 5pt"
              >
                <v-list-item @click="onSelectPertemuan(pt.value)">
                  <v-list-item-content>
                    <div> <v-icon left large> mdi-google-classroom </v-icon>{{ pt.text }} </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </template>
          <v-col v-if="false" cols="12" sm="12" md="12">
            <v-divider class="success" style="height: 2px; max-height: 2px" />
          </v-col>
        </v-row>

        <template v-if="kPertemuan">
          <template v-if="$getDeepObj(pendampingans, `${kPertemuan}`)">
            <v-tabs class="mt-2" v-model="tab" fixed-tabs centered color="success" background-color="green lighten-5">
              <v-tabs-slider></v-tabs-slider>
              <v-tab class="green--text">
                Informasi Umum
              </v-tab>
              <v-tab class="green--text">
                Laporan Kuesioner Sekolah
              </v-tab>
              <v-tab-item class="mt-2">
                <v-row>
                  <v-col cols="12" sm="12" md="12" class="mr-md-3">
                    <div class="text-right">
                      <v-btn
                        v-if="
                          api === 'kp'
                            ? $allow(keyAkses)
                            : Number($getDeepObj(pendampingans, `${kPertemuan}.instruktur_id`)) === Number(akunId) &&
                              $allow(keyAkses)
                        "
                        color="orange"
                        depressed
                        dark
                        @click="onEditPendampingan(kPertemuan)"
                      >
                        <v-icon left>mdi-pencil</v-icon> Ubah
                      </v-btn>
                    </div>
                  </v-col>
                  <template v-for="(item, i) in details">
                    <v-col :key="i" v-bind="item.grid" v-if="!item.hidden" class="pa-0">
                      <v-list-item>
                        <v-list-item-avatar v-if="item.icon" color="blue">
                          <v-icon dark>{{ item.icon }}</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <div>
                            <div v-html="item.title" />
                          </div>
                          <div class="link black--text body-2">
                            <div v-html="$getDeepObj(item, 'value') || ''" />
                          </div>
                          <template v-if="item.type === 'link'">
                            <v-expansion-panels flat>
                              <v-expansion-panel>
                                <v-expansion-panel-header class="px-0">
                                  <template v-slot:default="{ open }">
                                    <div>
                                      <v-toolbar flat>
                                        <v-toolbar-title class="body-1 ml-n4">
                                          <v-avatar color="blue" size="40">
                                            <v-icon dark>mdi-video</v-icon>
                                          </v-avatar>
                                          <span class="blue--text ml-2">
                                            {{ item.meeting.length || 0 }}
                                          </span>
                                          <span class="font-weight-medium">Link Pertemuan Daring</span>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <span class="text-right blue--text">
                                          {{ open ? 'Sembunyikan Link' : 'Lihat Selengkapnya' }}
                                        </span>
                                      </v-toolbar>
                                    </div>
                                  </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <template v-if="item.meeting.length > 0">
                                    <v-card color="yellow lighten-5" flat v-for="(meet, m) in item.meeting" :key="m">
                                      <v-row>
                                        <v-col v-for="child in item.child" :key="child.key" cols="12" sm="12" md="6">
                                          <v-list-item>
                                            <v-list-item-avatar :color="child.color">
                                              <v-icon dark>{{ child.icon }}</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                              <div>
                                                <div>
                                                  <span v-html="child.title"></span>
                                                  &nbsp;
                                                  <span>{{ $getDeepObj(meet, 'nama') || '' }}</span>
                                                </div>
                                              </div>
                                              <div class="link black--text body-2">
                                                <span class="blue--text body-2 my-1">{{
                                                  $getDeepObj(meet, child.key) || ''
                                                }}</span>
                                                <div>
                                                  <v-btn
                                                    small
                                                    outlined
                                                    color="orange"
                                                    :disabled="!$getDeepObj(meet, child.key)"
                                                    @click="toLink($getDeepObj(meet, child.key))"
                                                  >
                                                    <v-icon left>mdi-open-in-new</v-icon> Buka Link
                                                  </v-btn>
                                                  <v-btn
                                                    class="mx-md-1"
                                                    small
                                                    outlined
                                                    color="orange"
                                                    :disabled="!$getDeepObj(meet, child.key)"
                                                    @click="toCopy($getDeepObj(meet, child.key))"
                                                  >
                                                    <v-icon left>mdi-content-copy</v-icon> Salin Link
                                                  </v-btn>
                                                </div>
                                              </div>
                                            </v-list-item-content>
                                          </v-list-item>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12">
                                          <v-divider></v-divider>
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                  </template>
                                  <template v-else>
                                    <div class="text-center body-1">
                                      Belum ada data pertemuan daring
                                    </div>
                                  </template>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </template>
                          <template v-if="item.type === 'file'">
                            <div>
                              <v-btn
                                small
                                outlined
                                :disabled="!item.url_berkas"
                                color="orange"
                                @click="toLink(item.url_berkas)"
                              >
                                <v-icon left>mdi-open-in-new</v-icon> Lihat Berkas
                              </v-btn>
                            </div>
                          </template>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </template>
                </v-row>
              </v-tab-item>
              <v-tab-item class="mt-2">
                <v-alert
                  colored-border
                  dense
                  border="left"
                  color="warning"
                  icon="mdi-information"
                  class="bg-notif mt-3 mb-0 body-2"
                  dismissible
                  v-model="alertBorang"
                >
                  Mohon untuk melakukan pengecekan kembai laporan Sekolah karena terdapat tambahan data terkait
                  <b>Mekanisme Pembelajaran</b>.
                </v-alert>
                <v-row v-for="(item, s) in sekolah" :key="s">
                  <v-col cols="12" sm="12" md="12">
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-row no-gutters>
                          <v-col cols="12" md="4">
                            <v-list-item class="px-0">
                              <v-list-item-avatar color="blue">
                                <v-icon dark>mdi-hospital-building</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content class="py-0 px-1">
                                <div class="blue--text">
                                  {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                                </div>
                                <div class="black--text">
                                  <b>NPSN : </b>
                                  {{ $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0">
                                <v-list-item-title>
                                  <v-label color="caption"><small>Alamat Sekolah </small></v-label>
                                </v-list-item-title>
                                <div class="link black--text body-2">
                                  <div>{{ $getDeepObj(item, 'sekolah.data.alamat') || '-' }}</div>
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0">
                                <v-list-item-title>
                                  <v-label color="caption"><small>Status</small></v-label>
                                </v-list-item-title>
                                <v-list-item-subtitle class="link black--text body-2">
                                  <v-chip
                                    :color="
                                      $getDeepObj(item, 'psp_kp_sekolah_laporans.data.0.is_lengkap')
                                        ? 'success'
                                        : '#ff8425'
                                    "
                                    dark
                                    small
                                  >
                                    {{
                                      $getDeepObj(item, 'psp_kp_sekolah_laporans.data.0.is_lengkap')
                                        ? 'Sudah Lengkap'
                                        : 'Belum Lengkap'
                                    }}
                                  </v-chip>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0">
                                <v-list-item-title>
                                  <v-label color="caption"><small>Aksi</small></v-label>
                                </v-list-item-title>
                                <v-list-item-subtitle class="link black--text body-2">
                                  <template v-if="$allow('psp-peserta-pendampingan.update-laporan')">
                                    <v-btn small depressed color="primary" @click="onKuisioner(item)">
                                      <v-icon left>
                                        {{
                                          $getDeepObj(item, 'psp_kp_sekolah_laporans.data.0.is_lengkap')
                                            ? 'mdi-eye'
                                            : 'mdi-pencil'
                                        }}
                                      </v-icon>
                                      {{
                                        $getDeepObj(item, 'psp_kp_sekolah_laporans.data.0.is_lengkap')
                                          ? 'Lihat Detail'
                                          : 'Lengkapi'
                                      }}
                                    </v-btn>
                                  </template>
                                  <template v-else>
                                    <v-btn small depressed color="primary" @click="onKuisioner(item)">
                                      <v-icon left> mdi-eye </v-icon>
                                      Lihat Detail
                                    </v-btn>
                                  </template>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs>
          </template>
          <template v-else>
            <div class="text-center mt-5">
              <v-icon x-large>mdi-help-circle</v-icon>
              <div class="body-1 my-3">
                Belum ada pengaturan untuk <b>Jadwal Pertemuan {{ kPertemuan }}</b>
              </div>
              <div v-if="$allow('psp-peserta-kp.update-pendampingan')" class="body-1">
                Anda dapat melakukan pengaturan melalui tombol berikut
              </div>
              <div class="mt-4">
                <v-btn
                  v-if="$allow('psp-peserta-kp.update-pendampingan')"
                  color="primary"
                  depressed
                  @click="onEditPendampingan(kPertemuan)"
                >
                  <v-icon left>mdi-pencil</v-icon> Set Jadwal
                </v-btn>
              </div>
            </div>
          </template>
        </template>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" timeout="1000">
      Tautan berhasil disalin
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          tutup
        </v-btn>
      </template>
    </v-snackbar>
    <base-modal-full
      ref="modal"
      :title="formulir.title"
      :useSave="formulir.useSave"
      @save="onSave"
      @close="onCloseModal"
    >
      <component
        ref="formulir"
        :is="formulir.form"
        :id="formulir.id"
        :initValue="formulir.init"
        :jenis="api"
        :masters="masters"
        :isPreview="formulir.isPreview"
      />
    </base-modal-full>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import mixin from './mixin';
import FormKelompok from '../formulir/Kelompok';
import FormPendampingan from '../formulir/Pendampingan';
import FormKuisioner from '../formulir/Kuisioner';
import BaseBreadcrumbs from '@components/base/BaseBreadcrumbs';
export default {
  mixins: [mixin],
  components: { BaseBreadcrumbs, FormKelompok, FormPendampingan, FormKuisioner },
  data() {
    return {
      detail: {},
      kPertemuan: null,
      formulir: {},
      snackbar: false,
      tab: null,
      sekolah: [],
      masters: {},
      autosave: null,
      alertBorang: false,
    };
  },
  computed: {
    ...mapState('preferensi', {
      preferensi: (state) => state.data,
    }),

    breadcrumbs() {
      return [
        { text: 'Daftar Kelompok Pendamping KP', to: this.api === 'kp' ? 'diklat-pendampingan' : 'pendampingan' },
        { text: this.$getDeepObj(this, 'detail.nama') },
      ];
    },

    id() {
      return this.$route.params.detail_id || null;
    },

    api() {
      return this.$route.meta.api || 'kp';
    },

    akunId() {
      return this.$getDeepObj(this, 'preferensi.akun.akun_id');
    },

    keyAkses() {
      return this.api === 'kp' ? `psp-peserta-kp.update-pendampingan` : 'psp-peserta-pendampingan.update';
    },

    pendampingans() {
      return this.$arrToObj(this.$getDeepObj(this, 'detail.psp_kp_pendampingans.data') || [], 'pendampingan_ke');
    },

    details() {
      const item = this.$getDeepObj(this, `pendampingans.${this.kPertemuan}`) || {};
      const berkases = this.$arrToObj(this.$getDeepObj(item, 'psp_kp_berkases.data') || [], 'k_kp_berkas_psp');
      return [
        {
          icon: 'mdi-calendar-month',
          title: 'Waktu Pelaksanaan',
          value: this.$localDate(item.tgl_pendampingan),
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          icon: 'mdi-account',
          title: `<span class='body-1 blue--text'>${this.$getDeepObj(item, 'akun_instruktur.data.nama')}</span>`,
          value: `<span class='black--text'><b>Email: </b>${this.$getDeepObj(item, 'akun_instruktur.data.email') ||
            '-'}</span>`,
          grid: { cols: 12, md: 6, sm: 12 },
          hidden: this.api === 'pendampingan',
        },
        {
          icon: '',
          title: '',
          value: '',
          type: 'link',
          meeting: (item && item.data_meeting) || [],
          child: [
            {
              key: 'url_meeting',
              icon: 'mdi-video',
              color: 'primary',
              title: `<span class='black--text body-2 font-weight-bold'>Link Pertemuan Daring</span>`,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              key: 'url_recording',
              icon: 'mdi-video-check',
              color: 'success',
              title: `<span class='black--text body-2 font-weight-bold'>Link Rekaman Daring</span>`,
              grid: { cols: 12, md: 6, sm: 12 },
            },
          ],
          grid: { cols: 12, md: 12, sm: 12 },
        },
        {
          icon: 'mdi-file',
          title: `<span class='black--text body-2 font-weight-bold'>Laporan Presensi</span>`,
          value: '',
          type: 'file',
          url_berkas: this.$getDeepObj(berkases, '1.url_berkas') || null,
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          icon: 'mdi-file',
          title: `<span class='black--text body-2 font-weight-bold'>Laporan Pendampingan Komite Pembelajaran</span>`,
          value: '',
          type: 'file',
          url_berkas: this.$getDeepObj(berkases, '99.url_berkas') || null,
          grid: { cols: 12, md: 6, sm: 12 },
        },
      ];
    },

    mPertemuan() {
      return [
        {
          text: 'Jadwal 1',
          value: 1,
          disabled:
            this.api === 'kp'
              ? false
              : Number(this.$getDeepObj(this.pendampingans, `1.instruktur_id`)) !== Number(this.akunId),
        },
        {
          text: 'Jadwal 2',
          value: 2,
          disabled:
            this.api === 'kp'
              ? false
              : Number(this.$getDeepObj(this.pendampingans, `2.instruktur_id`)) !== Number(this.akunId),
        },
        {
          text: 'Jadwal 3',
          value: 3,
          disabled:
            this.api === 'kp'
              ? false
              : Number(this.$getDeepObj(this.pendampingans, `3.instruktur_id`)) !== Number(this.akunId),
        },
        {
          text: 'Jadwal 4',
          value: 4,
          disabled:
            this.api === 'kp'
              ? false
              : Number(this.$getDeepObj(this.pendampingans, `4.instruktur_id`)) !== Number(this.akunId),
        },
      ];
    },
  },
  created() {
    this.getPendampingan();
    this.kPertemuan = 1;
  },
  methods: {
    ...mapActions('diklatDkp', {
      getDetail: 'getDetail',
      update: 'update',
      updatePendampingan: 'updatePendampingan',
      updateLaporan: 'updateLaporan',
      getSekolah: 'getSekolah',
      getInstrument: 'getInstrument',
      getPic: 'getPic',
    }),

    onSelectPertemuan(kPertemuan) {
      this.kPertemuan = kPertemuan;
      this.sekolah = [];
      this.getSekolahPendampingan(kPertemuan);
    },

    toLink(url) {
      window.open(url);
    },

    toCopy(url) {
      const elem = document.createElement('textarea');
      elem.value = url;
      document.body.appendChild(elem);
      elem.select();
      document.execCommand('copy');
      document.body.removeChild(elem);
      this.snackbar = true;
    },

    getSekolahPendampingan(kPendampingan) {
      const pendampingan = this.$getDeepObj(this, `pendampingans.${kPendampingan || 1}`) || null;
      if (pendampingan && pendampingan.psp_kp_pendampingan_id) {
        this.getSekolah({ id: this.$getDeepObj(pendampingan, 'psp_kp_pendampingan_id'), params: { count: 20 } }).then(
          ({ data }) => {
            this.sekolah = data || [];
            const statusLengkap = this.sekolah.map((item) =>
              Boolean(this.$getDeepObj(item, 'psp_kp_sekolah_laporans.data.0.is_lengkap') || 0)
            );
            this.alertBorang = statusLengkap.includes(false);
          }
        );
      }
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
